<template>
  <div
    v-if="isRunning"
    class="flex h-4 w-full flex-row items-center gap-1 overflow-hidden"
    role="progressbar"
    aria-busy="true"
  >
    <div class="track track-left bg-secondary-container h-2 shrink-0 rounded-full"></div>
    <div class="indeterminate-wave h-full shrink-0">
      <BaseWavyProgressIndicator
        class="stroke-primary h-full w-full"
        :thickness="8"
        :wavelength="20"
        :animate-amplitude="true"
        :duration="2200"
      />
    </div>
    <div class="bg-secondary-container h-2 shrink grow rounded-full"></div>
  </div>
  <div v-else class="h-4 w-full"></div>
</template>
<script lang="ts" setup>
  import BaseWavyProgressIndicator from './BaseWavyProgressIndicator.vue'

  interface Props {
    isRunning: boolean
  }

  defineProps<Props>()
</script>
<style scoped>
  .track-left {
    animation: track-left 2.2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  }

  .indeterminate-wave {
    animation: indeterminate-wave-grow 2.2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  }

  @keyframes track-left {
    0%,
    10% {
      width: 0%;
    }
    100% {
      width: 100%;
    }
  }

  @keyframes indeterminate-wave-grow {
    0%,
    100% {
      width: 0%;
    }
    50% {
      width: 50%;
    }
  }
</style>
